import { render, staticRenderFns } from "./AddVariantsMenu.vue?vue&type=template&id=1811ba16&scoped=true"
import script from "./AddVariantsMenu.vue?vue&type=script&lang=js"
export * from "./AddVariantsMenu.vue?vue&type=script&lang=js"
import style0 from "./AddVariantsMenu.vue?vue&type=style&index=0&id=1811ba16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1811ba16",
  null
  
)

export default component.exports